<template>
  <div>
    <div class="clearfix">
      <span class="pulled-right" v-for="chartType in chart.types" :key="chartType.type">
        <label class="checkbox" :for="chartType.type">
          <input type="checkbox" :id="chartType.type" :checked="chartType.visible"
              @click="changeTypeVisibility(chartType.type)" />
          <span :style="{ background: chartType.color }"></span>
          {{ $t(`boxes.${chartType.type}.title`) }}
        </label>
      </span>
    </div>
    <div id="c3-chart"></div>
    <p class="info-text">{{$t('analytics.info.cacheDelay')}}</p>
  </div>
</template>

<script>
  import c3 from 'c3';
  import { mapGetters } from 'vuex';
  import 'c3/c3.min.css';

  export default {
    computed: mapGetters({
      chart: 'metrics/chart',
    }),
    data() {
      return {
        c3Chart: null,
      };
    },
    methods: {
      updateChart() {
        if (!this.hasData()) {
          this.c3Chart.unload();
          return;
        }

        this.c3Chart.load({
          json: this.chart.data,
          keys: this.getKeys(),
        });
      },
      changeTypeVisibility(type) {
        this.c3Chart.toggle(type);
      },
      getKeys() {
        return this.hasData() ? this.chart.keys : { value: [] };
      },
      hasData() {
        return this.chart.data.length > 0;
      },
    },
    mounted() {
      this.c3Chart = c3.generate({
        bindto: '#c3-chart',
        data: {
          json: this.chart.data,
          keys: this.getKeys(),
          empty: {
            label: {
              text: this.$t('chart.noData'),
            },
          },
        },
        color: {
          pattern: this.chart.colors,
        },
        legend: { show: false },
        tooltip: { show: false },
        axis: {
          x: { type: 'category', show: true },
          y: { show: true },
        },
        grid: {
          x: { show: true },
          y: { show: true },
        },
      });
    },
    watch: {
      chart: {
        handler: 'updateChart',
        deep: true,
      },
    },
    beforeDestroyed() {
      this.c3Chart = this.c3Chart.destroy();
    },
  };
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/charts/LineChart.vue